(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Desktop: Lichtkegel & Bild-Parallax folgen der Maus (setzt nur CSS-Variablen) */
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var active = null;
    var frame = null;
    var lastEvent = null;

    function reset(gallery) {
      if (!gallery) return;
      gallery.style.removeProperty('--dof-dx');
      gallery.style.removeProperty('--dof-dy');
      gallery.style.removeProperty('--dof-mx');
      gallery.style.removeProperty('--dof-my');
    }

    document.addEventListener(
      'pointermove',
      function (event) {
        lastEvent = event;
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          var target = lastEvent.target;
          var gallery = target && target.closest ? target.closest('.product-card .card-gallery') : null;

          if (gallery !== active) {
            reset(active);
            active = gallery;
          }
          if (!gallery) return;

          var rect = gallery.getBoundingClientRect();
          var x = (lastEvent.clientX - rect.left) / rect.width;
          var y = (lastEvent.clientY - rect.top) / rect.height;
          gallery.style.setProperty('--dof-mx', (x * 100).toFixed(1) + '%');
          gallery.style.setProperty('--dof-my', (y * 100).toFixed(1) + '%');
          gallery.style.setProperty('--dof-dx', ((x - 0.5) * 2).toFixed(3));
          gallery.style.setProperty('--dof-dy', ((y - 0.5) * 2).toFixed(3));
        });
      },
      { passive: true }
    );

    document.addEventListener('pointerleave', function () {
      reset(active);
      active = null;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dof-hero-title"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Desktop: roter Schatten folgt leicht der Maus (rein visuell) */
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var frame = null;

    document.addEventListener(
      'pointermove',
      function (event) {
        var title = document.querySelector('[data-dof-hero-title]');
        if (!title || frame) return;

        frame = window.requestAnimationFrame(function () {
          frame = null;
          var hero = title.closest('.hero') || title;
          var rect = hero.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;

          var x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
          var y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
          title.style.setProperty('--dof-ht-mx', Math.max(-1, Math.min(1, x)).toFixed(3));
          title.style.setProperty('--dof-ht-my', Math.max(-1, Math.min(1, y)).toFixed(3));
        });
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
